import querystring from 'query-string';
import { useContext } from 'react';
import { ApiClientService, useApiClient } from '../../features/api_client';
import { AuthContext } from '../../features/auth/contexts';
export const useSearchWorkspaceSiteByName = () => {
    const { entityId } = useContext(AuthContext);
    const momClient = useApiClient(ApiClientService.MOM);
    const checkForDuplicate = async (name, currentSiteId) => {
        if (!name || !name.trim()) {
            return false;
        }
        try {
            const queryParams = querystring.stringify({ search: name.trim() });
            const { data: response } = await momClient.get(`/v1/entities/${entityId}/sites?${queryParams}`);
            // Check for exact match (case-insensitive)
            const exactMatch = response.data?.find((site) => site.name.toLowerCase() === name.trim().toLowerCase() && site.id !== currentSiteId);
            return !!exactMatch;
        }
        catch (error) {
            console.error('Error checking for duplicate workspace site name:', error);
            // On error, don't block the user - let server-side validation handle it
            return false;
        }
    };
    return {
        checkForDuplicate,
    };
};
